import { render, staticRenderFns } from "./WelcomeClinician.vue?vue&type=template&id=84153a46"
import script from "./WelcomeClinician.vue?vue&type=script&lang=js"
export * from "./WelcomeClinician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports